var render, staticRenderFns
import script from "./ContactFormList.vue?vue&type=script&lang=js&"
export * from "./ContactFormList.vue?vue&type=script&lang=js&"
import style0 from "./ContactFormList.vue?vue&type=style&index=0&id=7f9c995c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f9c995c",
  null
  
)

export default component.exports